<template>
  <form-item-wrapper
    :designer="designer"
    :field="field"
    :design-state="designState"
    :title="field.options.label"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex"
    :sub-form-col-index="subFormColIndex"
    :sub-form-row-id="subFormRowId"
  >
    <van-field
      :name="field.options.name"
      v-model="fieldModel"
      clickable
      readonly
      is-link
      :label="fieldLabel"
      :label-width="fieldLabelWidth"
      :placeholder="field.options.placeholder"
      :disabled="fieldDisabled || field.options.readonly"
      :required="field.options.required"
      :rules="rules"
      :size="size"
      @click="showDatePicker"
    >
      <template #right-icon>
        <clearIcon v-if="clearable"></clearIcon>
      </template>
    </van-field>
    <van-popup v-model:show="showPickerFlag" round position="bottom" teleport="body">
      <van-date-picker :columns-type="columnType" v-model="currentDate" :title="field.options.placeholder" :min-date="minDate" :max-date="maxDate" @confirm="handleConfirm" @cancel="handleCancel" />
    </van-popup>
  </form-item-wrapper>
</template>

<script>
import { inject, reactive, ref, toRefs, onMounted, onBeforeUnmount, computed } from 'vue';
import { useI18n } from '@/utils/i18n';
import { useField } from '@/components/form-designer/form-widget/field-widget/fieldMixin';
import FormItemWrapper from '@/components/form-designer/form-widget/field-widget/form-item-wrapper';
import { formatDate, formatArray, parseDate } from '@/utils/date-util';
import clearIcon from '../components/clear.vue';
import dayjs from 'dayjs';

export default {
  componentName: 'FieldWidget',
  components: {
    FormItemWrapper,
    clearIcon,
  },
  name: 'm-date-widget',
  props: {
    designState: {
      default: false,
      type: Boolean,
    },
    designer: Object,
    field: Object,
    indexOfParentList: Number,
    parentList: Array,

    parentWidget: Object,

    subFormColIndex: {
      default: -1,
      /* 子表单组件列索引，从0开始计数 */
      type: Number,
    },
    subFormRowId: {
      default: '',
      /* 子表单组件行Id，唯一id且不可变 */
      type: String,
    },
    subFormRowIndex: {
      default: -1,
      /* 子表单组件行索引，从0开始计数 */
      type: Number,
    },
  },
  setup(props) {
    const refList = inject('refList');
    const globalOptionData = inject('globalOptionData');
    const globalModel = inject('globalModel');

    const { i18nt } = useI18n();

    const data = reactive({
      currentDate: [], //new Date(),
      fieldModel: '',
      noChangeEventFlag: true, //van-field组件没有change事件！！

      oldFieldValue: '', //field组件change之前的值

      rules: [],
      showPickerFlag: false,
    });
    const fieldMixin = useField(data);

    onMounted(() => {
      fieldMixin.handleOnMounted();
    });

    onBeforeUnmount(() => {
      fieldMixin.unregisterFromRefList();
    });

    const columnType = computed(() => {
      let type = ['year', 'month', 'day'];
      let typeColumns = (props.field.options.format || 'yyyy-MM-dd')
        .replace(/\/|年|月|日/g, '-')
        .replace(/\-$/, '')
        .split('-');
      return type.splice(0, typeColumns.length);
    });

    const minDate = computed(() => {
      if (!props.field.options.minDate) {
        return undefined;
      }
      return parseDate(props.field.options.minDate, 'YYYY-MM-DD').toDate();
    });
    const maxDate = computed(() => {
      if (!props.field.options.maxDate) {
        return undefined;
      }
      return parseDate(props.field.options.maxDate, 'YYYY-MM-DD').toDate();
    });

    onMounted(() => {
      fieldMixin.handleOnMounted();
    });

    onBeforeUnmount(() => {
      fieldMixin.unregisterFromRefList();
    });

    const showDatePicker = e => {
      if (!!props.designState) {
        data.showPickerFlag = false;
        return;
      }

      if (props.field.options.readonly || fieldMixin.isReadMode.value || fieldMixin.fieldDisabled.value) return;

      if (!data.fieldModel) {
        data.currentDate = dayjs().add(1, 'M').toArray().splice(0, columnType.value.length);
      } else {
        data.currentDate = dayjs(data.fieldModel).add(1, 'M').toArray().splice(0, columnType.value.length);
      }

      data.showPickerFlag = true;
      fieldMixin.handleFocusCustomEvent(e);
    };

    const handleConfirm = value => {
      data.fieldModel = formatDate(value.selectedValues, props.field.options.format);

      fieldMixin.syncUpdateFormModel(data.fieldModel);
      fieldMixin.handleOnConfirm(data.fieldModel);
      fieldMixin.handleChangeEvent(data.fieldModel);
      fieldMixin.handleBlurCustomEvent();
      data.showPickerFlag = false;
    };

    const handleCancel = () => {
      data.showPickerFlag = false;
    };

    fieldMixin.registerToRefList();
    fieldMixin.initFieldModel();
    fieldMixin.initEventHandler();
    fieldMixin.buildFieldRules();

    fieldMixin.handleOnCreated();

    return {
      i18nt,
      ...fieldMixin,
      ...toRefs(data),

      columnType,
      handleCancel,
      handleConfirm,
      maxDate,
      minDate,

      showDatePicker,
    };
  },
};
</script>

<style scoped></style>
